import {AfterViewInit, ChangeDetectionStrategy, Component, inject, input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {AsyncPipe, NgTemplateOutlet} from '@angular/common';
import {SearchBoxDirective} from '../../directives/searchbox/searchbox.directive';

@Component({
    selector: 'xui-material-searchbox',
    templateUrl: './material-search-box.component.html',
    styleUrls: ['./material-search-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule,
      MatAutocompleteModule, MatTableModule, MatSortModule,
      ReactiveFormsModule, AsyncPipe, NgTemplateOutlet, SearchBoxDirective
    ]
})
export class MaterialSearchBoxComponent implements OnInit, AfterViewInit {
  private breakpointObserver = inject(BreakpointObserver);

  private searchResultsSubject: BehaviorSubject<any[]> = new BehaviorSubject([]);
  searchResults$: Observable<any[]> = this.searchResultsSubject.asObservable();
  results: any[] = [];
  dataSource = new MatTableDataSource(this.results);
  isVisible = false;
  displayedColumns: string[] = ['profileId', 'firstName', 'surname', 'nickname', 'cell', 'tel', 'identityNumber'];
  searchFormControl = new UntypedFormControl();
  readonly searchObservable = input<((query: string) => Observable<any[]>) | null>(null);
  readonly resultsCardTemplate = input<TemplateRef<any> | null>(null);
  @ViewChild(MatSort) sort: MatSort;


  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  isNotHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => !result.matches),
      shareReplay()
    );

  ngOnInit() {
    if (this.searchObservable() === null) { throw Error('SearchObservable is a required input'); }
    if (this.resultsCardTemplate() === null) { throw Error('displayResultsCardTemplate is a required input'); }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  toggleSearch() {
    this.isVisible = !this.isVisible;
  }

  clearSearch() {
    this.searchResultsSubject.next([]);
    this.results = [];
  }

  rowSelected(option: any) {
  }

  onSearchResults(results: any[]) {
    this.searchResultsSubject.next(results);
    this.results = results;
    this.dataSource = new MatTableDataSource<any>(results);
    this.dataSource.sort = this.sort;
  }

  onError(errorMessage: string) {
    console.error(errorMessage);
  }
}
